import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CountryISO, NgxIntlTelInputModule, SearchCountryField } from '@justin-s/ngx-intl-tel-input';
import { SharedModule } from '../../../../../shared/shared.module';
import { Country } from '../../../../../models/country.models';
import countries from '../../../../../../assets/json/countries.json';
import { civilityOptions } from '../../../../../shared/utils/data/etablissments-data';
import { AlertDialogService } from '../../../../../services/alert-dialog.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-final-step-add-establishment',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    NgxIntlTelInputModule,
    SvgIconComponent,
    SharedModule,
    NgxIntlTelInputModule
  ],
  templateUrl: './final-step-add-establishment.component.html',
  styleUrls: ['./final-step-add-establishment.component.scss']
})
export class FinalStepAddEstablishmentComponent {
  @Input() form!: FormGroup;
  @Input() loading = false;
  @Output() onSubmit = new EventEmitter<void>();

  countriesList: Country[] = countries;
  separateDialCode = false;
  phoneMaxLength = 10;

  protected readonly CountryISO = CountryISO;
  protected readonly SearchCountryField = SearchCountryField;
  protected readonly civilityOptions = civilityOptions;

  private fb = inject(FormBuilder);

  constructor(
    private alertDialogService: AlertDialogService
  ) {}

  get contacts(): FormArray {
    return this.form.get('persons') as FormArray;
  }

  deleteNewContact(index: number): void {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Confirmation',
        'Êtes-vous sûr(e) de vouloir supprimer ce contact ? Toutes les informations associées seront perdues.',
        'Supprimer',
        'Annuler'
      )
      ?.subscribe((res) => {
        if (res) {
          this.contacts.removeAt(index);
        }
      });
  }

  getImage(images: string[], index: number) {
    const photo1 = this.contacts.controls[index].get('contactPhoto1');
    const photo2 = this.contacts.controls[index].get('contactPhoto2');
    photo1?.patchValue('');
    photo2?.patchValue('');

    if (images[0]) photo1?.patchValue(images[0]);
    if (images[1]) photo2?.patchValue(images[1]);
  }

  addNewContact(): void {
    this.contacts.push(
      this.fb.group({
        civility: ['MONSIEUR', Validators.required],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        fullnamepersonnecontact: [''],
        fonction: ['', Validators.required],
        mail: ['', [Validators.required, Validators.email]],
        numTel: ['', Validators.required],
        title: [''],
        contactPhoto1: [''],
        contactPhoto2: [''],
      })
    );
  }
}
